(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dynamic-video-carousel"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var SECTION_SELECTOR = '[data-video-carousel]';

    function prefersReducedMotion() {
      return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    }

    function scrollBehavior() {
      return prefersReducedMotion() ? 'auto' : 'smooth';
    }

    function embedUrl(provider, id) {
      if (provider === 'vimeo') {
        return 'https://player.vimeo.com/video/' + encodeURIComponent(id) + '?autoplay=1&playsinline=1';
      }

      return 'https://www.youtube.com/embed/' + encodeURIComponent(id) + '?autoplay=1&playsinline=1&rel=0';
    }

    function stopAll(root, keep) {
      var items = root.querySelectorAll('.video-carousel__item.is-playing');

      Array.prototype.forEach.call(items, function (item) {
        if (item === keep) return;

        var player = item.querySelector('[data-video-carousel-player]');
        if (player) player.innerHTML = '';
        item.classList.remove('is-playing');
      });
    }

    function play(root, card) {
      var item = card.closest('.video-carousel__item');
      var player = item && item.querySelector('[data-video-carousel-player]');
      var id = card.getAttribute('data-video-id');

      if (!item || !player || !id) return false;

      stopAll(root, item);

      var iframe = document.createElement('iframe');
      iframe.src = embedUrl(card.getAttribute('data-video-provider'), id);
      iframe.title = card.getAttribute('aria-label') || '';
      iframe.setAttribute('allow', 'autoplay; encrypted-media; picture-in-picture; fullscreen');
      iframe.setAttribute('allowfullscreen', 'allowfullscreen');

      player.innerHTML = '';
      player.appendChild(iframe);
      item.classList.add('is-playing');

      try {
        iframe.focus({ preventScroll: true });
      } catch (error) {
        /* focus is a progressive enhancement */
      }

      return true;
    }

    function step(track) {
      var item = track.querySelector('.video-carousel__item');
      if (!item) return track.clientWidth;

      var styles = window.getComputedStyle(track);
      var gap = parseFloat(styles.columnGap || styles.gap || '0') || 0;

      return item.getBoundingClientRect().width + gap;
    }

    function updateArrows(root) {
      var track = root.querySelector('[data-video-carousel-track]');
      var prev = root.querySelector('[data-video-carousel-prev]');
      var next = root.querySelector('[data-video-carousel-next]');

      if (!track) return;

      var overflows = track.scrollWidth - track.clientWidth > 1;
      var maxScroll = track.scrollWidth - track.clientWidth;

      if (prev) {
        prev.hidden = !overflows;
        prev.disabled = track.scrollLeft <= 1;
      }

      if (next) {
        next.hidden = !overflows;
        next.disabled = track.scrollLeft >= maxScroll - 1;
      }
    }

    function fixThumbnails(root) {
      var thumbnails = root.querySelectorAll('[data-video-carousel-thumbnail]');

      Array.prototype.forEach.call(thumbnails, function (image) {
        var fallback = image.getAttribute('data-fallback-src');
        if (!fallback) return;

        var swap = function () {
          if (image.src === fallback) return;
          image.src = fallback;
        };

        if (image.complete && image.naturalWidth === 0) {
          swap();
          return;
        }

        image.addEventListener('error', swap, { once: true });
      });
    }

    function init(root) {
      if (!root || root.hasAttribute('data-video-carousel-ready')) return;
      root.setAttribute('data-video-carousel-ready', 'true');

      var track = root.querySelector('[data-video-carousel-track]');
      if (!track) return;

      fixThumbnails(root);

      track.addEventListener('click', function (event) {
        if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;

        var card = event.target.closest('[data-video-carousel-card]');
        if (!card || !track.contains(card)) return;

        if (play(root, card)) event.preventDefault();
      });

      var prev = root.querySelector('[data-video-carousel-prev]');
      var next = root.querySelector('[data-video-carousel-next]');

      if (prev) {
        prev.addEventListener('click', function () {
          track.scrollBy({ left: -step(track), behavior: scrollBehavior() });
        });
      }

      if (next) {
        next.addEventListener('click', function () {
          track.scrollBy({ left: step(track), behavior: scrollBehavior() });
        });
      }

      track.addEventListener('scroll', function () {
        window.requestAnimationFrame(function () {
          updateArrows(root);
        });
      });

      if (window.ResizeObserver) {
        new window.ResizeObserver(function () {
          updateArrows(root);
        }).observe(track);
      } else {
        window.addEventListener('resize', function () {
          updateArrows(root);
        });
      }

      updateArrows(root);
    }

    function initAll(scope) {
      var container = scope || document;
      var roots = container.querySelectorAll(SECTION_SELECTOR);

      Array.prototype.forEach.call(roots, init);

      if (container.matches && container.matches(SECTION_SELECTOR)) init(container);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        initAll();
      });
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', function (event) {
      initAll(event.target);
    });

    document.addEventListener('shopify:block:select', function (event) {
      var item = event.target.closest ? event.target.closest('.video-carousel__item') : null;
      if (!item) return;

      var track = item.closest('[data-video-carousel-track]');
      if (!track) return;

      track.scrollTo({ left: item.offsetLeft - track.offsetLeft, behavior: scrollBehavior() });
    });

    document.addEventListener('shopify:block:deselect', function (event) {
      var root = event.target.closest ? event.target.closest(SECTION_SELECTOR) : null;
      if (root) stopAll(root, null);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-high-variant"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('product-form:cart:request', async (event) => {
    if (window.CART_REDIRECTION_ENABLED) {
      return; 
    }

    // Cancel default cart addition processing
    event.preventDefault();

    try {
      // Convert FormData to array format (expected by AddToCartFlyout)
      const formData = event.detail.form;
      const formDataArray = [];
      for (let [key, value] of formData.entries()) {
        formDataArray.push({ name: key, value: value });
      }

      const submitButton = document.querySelector('button[type="submit"], input[type="submit"]');
      
        const addToCartFlyout = new window.AddToCartFlyout(formDataArray, {
          atcButton: submitButton,
          settings: {
            moneyFormat: window.SHOP_MONEY_FORMAT
          }
        });

        // Wait for AddToCartFlyout completion and return actual response data
        const handleComplete = (completeEvent) => {
          document.removeEventListener('addToCartFlyout:complete', handleComplete);
          document.removeEventListener('addToCartFlyout:error', handleError);
          event.detail.resolve(completeEvent.detail.responseData);
        };

        const handleError = (errorEvent) => {
          document.removeEventListener('addToCartFlyout:complete', handleComplete);
          document.removeEventListener('addToCartFlyout:error', handleError);
          event.detail.reject(errorEvent.detail.error);
        };

        document.addEventListener('addToCartFlyout:complete', handleComplete);
        document.addEventListener('addToCartFlyout:error', handleError);

    } catch (error) {
      console.error('AddToCartFlyout error:', error);
      event.detail.reject(error);
    }
  });

  document.addEventListener('product-form:cart:navigate', (event) => {
    if (!window.CART_REDIRECTION_ENABLED) {
      event.preventDefault();
    }
  });

  document.addEventListener('product-form:submit:success', (event) => {
    if (window.CART_REDIRECTION_ENABLED) {
      window.location.href = window.Theme.routes.cart_url;
    }
  });

  } catch(e) { console.error(e); }
})();
})();
